export default __webpack_public_path__ + "static/media/zoom.37425b7a.svg";